
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WLHomeServeExpertBlock extends Vue {
  @Prop({ type: String, required: true })
  private icon!: string;

  @Prop({
    type: Object,
    required: true,
    validator(value: any): boolean {
      return value.title && value.desc;
    },
  })
  private i18n!: { title: string; desc: string };
}
